import * as THREE from 'three';
import * as objLoader from 'three-obj-loader';
objLoader(THREE);

export const importObj = (url, cb, key) => {
  this.THREE = THREE;
  const _this = this;
  const loader = new this.THREE.OBJLoader();
  loader.load(url,
    function (object) {
      const obj = new THREE.Geometry().fromBufferGeometry(object.children[0].geometry);
      // obj.computeBoundingBox();
      // object.traverse(function (child) {
      //   console.log(child)
      //   if (child.material !== undefined) child.material.side = _this.THREE.DoubleSide;

      // });
      cb && cb(obj, key)
    },
    // function (xhr) { console.log((xhr.loaded / xhr.total * 100) + '% loaded'); },
    // function (error) { console.log('an error happened: ', error); }
  );
} 


// WEBPACK FOOTER //
// ./src/components/Results/ResultsScene/util/import.js